export default "__VITE_ASSET__DYe9IQk5__"